import React, {useEffect, useState} from 'react'
import {getAnalyticsData} from '../../services/dataService';
import SurveyTitle from './SurveyTitle';
import AnalyticsPagesContainer from './AnalyticsPagesContainer';



export default function SurveyAnalyticsRoot(props) {

    const [surveyInfo, setSurveyInfo] = useState({ questionnaireInfo: null });


    const getKey = () => {
        if (props.encryptedParam && props.encryptedParam.indexOf("?k=") === 0)
            return encodeURIComponent(props.encryptedParam.substring(3));
        return null;
    }
 
    useEffect(() => {
      const fetchData = async () => {
        const result = await getAnalyticsData(getKey());
    
        setSurveyInfo(result.data);
      };
    
      fetchData();
    }, []);


    if(surveyInfo.form){
        return (
            <div className="survey-analytics-main-container" >
               <SurveyTitle title={surveyInfo.form.title}/>
               <AnalyticsPagesContainer form={surveyInfo.form} data={surveyInfo.data}></AnalyticsPagesContainer>
            </div>
        )    
    }
    return "";
}


